// Created by hejikun on 2017/11/2 0002.
let ucenter = [
  {
    path: '/ucenter_authorization',
    name: '授权管理',
    component: () => import('@/pages/ucenter/ucenter_authorization')
  },
  {
    path: '/ucenter',
    name: '个人中心',
    component: () => import('@/pages/ucenter/index')
  },
  {
    path: '/ucenter_new',
    name: '个人中心',
    component: () => import('@/pages/ucenter/index_new')
  },
  {
    path: '/ucenter_register_evaluate',
    name: '挂号评价',
    component: () => import('@/pages/ucenter/ucenter_register_evaluate')
  },
  {
    path: '/ucenter_col_doc',
    name: '放号提醒',
    component: () => import('@/pages/ucenter/ucenter_col_doc')
  },
  {
    path: '/ucenter_register_evaluate_new',
    name: '挂号评价',
    component: () => import('@/pages/ucenter/ucenter_register_evaluate_new')
  },
  {
    path: '/ucenter_register_moreEvaluate',
    name: '医生评价',
    // component: () => import('@/pages/ucenter/ucenter_register_moreEvaluate')
    component: () => import('@/pages/ucenter/ucenter_register_moreEvaluate')
  },
  {
    path: '/ucenter_register_moreEvaluate_new',
    name: '医生评价',
    // component: () => import('@/pages/ucenter/ucenter_register_moreEvaluate')
    component: () => import('@/pages/ucenter/ucenter_register_moreEvaluate_new')
  },
  {
    path: '/ucenter_register_moreHosEvaluate',
    name: '医院评价',
    component: () => import('@/pages/ucenter/ucenter_register_moreHosEvaluate')
  },
  {
    path: '/ucenter_register_records',
    name: '疫苗记录',
    component: () => import('@/pages/ucenter/ucenter_register_records')
  },
  {
    path: '/ucenter_register_records1',
    name: '历史订单查询',
    component: () => import('@/pages/ucenter/ucenter_register_records1')
  },
  {
    path: '/ucenter_register_records_new',
    name: '挂号记录',
    component: () => import('@/pages/ucenter/ucenter_register_records_new')
  },
  {
    path: '/ucenter_register_records_detail',
    name: '记录详情',
    component: () => import('@/pages/ucenter/ucenter_register_records_detail')
  },
  {
    path: '/ucenter_register_records_detail_new',
    name: '记录详情',
    component: () => import('@/pages/ucenter/ucenter_register_records_detail_new')
  },
  {
    path: '/ucenter_register_records_pay',
    name: '记录详情',
    component: () => import('@/pages/ucenter/ucenter_register_records_pay')
  },
  {
    path: '/ucenter_register_records_pay_new',
    name: '记录详情',
    component: () => import('@/pages/ucenter/ucenter_register_records_pay_new')
  },
  {
    path: '/ucenter_physical_detail',
    name: '记录详情',
    component: () => import('@/pages/ucenter/ucenter_physical_detail')
  },
  {
    path: '/ucenter_physical_pay',
    name: '记录详情',
    component: () => import('@/pages/ucenter/ucenter_physical_pay')
  },
  {
    path: '/ucenter_ask_records',
    name: '咨询记录',
    component: () => import('@/pages/ucenter/ucenter_ask_records')
  },
  {
    path: '/ucenter_course',
    name: '健康课堂',
    component: () => import('@/pages/ucenter/ucenter_course')
  },
  {
    path: '/ucenter_physical_examination',
    name: '我的体检',
    component: () => import('@/pages/ucenter/ucenter_physical_examination')
  },
  {
    path: '/ucenter_counselor',
    name: '我的就诊顾问',
    component: () => import('@/pages/ucenter/ucenter_counselor')
  },
  {
    path: '/ucenter_persons',
    name: '就诊人管理',
    component: () => import('@/pages/ucenter/ucenter_persons')
  },
  {
    path: '/ucenter_persons_new',
    name: '就诊人管理',
    component: () => import('@/pages/ucenter/ucenter_persons_new')
  },

  {
    path: '/ucenter_add_patient_new',
    name: '电子健康卡注册',
    component: () => import('@/pages/ucenter/ucenter_add_patient_new')
  },
  {
    path: '/ucenter_add_patient_h5',
    name: '绑定就诊人',
    component: () => import('@/pages/ucenter/ucenter_add_patient_h5')
  },
  {
    path: '/ucenter_add_patient_old',
    name: '电子健康卡注册',
    component: () => import('@/pages/ucenter/ucenter_add_patient_old')
  },
  {
    path: '/ucenter_modify_patient_new',
    name: '修改就诊人',
    component: () => import('@/pages/ucenter/ucenter_modify_patient_new')
  },
  {
    path: '/ucenter_modify_patient_new',
    name: '修改就诊人',
    component: () => import('@/pages/ucenter/ucenter_modify_patient_new')
  },
  {
    path: '/ucenter_patient_detail',
    name: '就诊人详情',
    component: () => import('@/pages/ucenter/ucenter_patient_detail')
  },
  {
    path: '/ucenter_patient_detail_new',
    name: '就诊人详情',
    component: () => import('@/pages/ucenter/ucenter_patient_detail_new')
  },
  {
    path: '/ucenter_collections',
    name: '关注收藏',
    component: () => import('@/pages/ucenter/ucenter_collections')
  },
  {
    path: '/ucenter_collections_new',
    name: '关注收藏',
    component: () => import('@/pages/ucenter/ucenter_collections_new')
  },
  // {
  //   path: '/ucenter_fees_records',
  //   name: '我的缴费',
  //   component: () => import('@/pages/ucenter/ucenter_fees_records')
  // },
  {
    path: '/ucenter_contact',
    name: '联系客服',
    component: () => import('@/pages/ucenter/ucenter_contact')
  },
  {
    path: '/ucenter_feedback',
    name: '意见反馈',
    component: () => import('@/pages/ucenter/ucenter_feedback')
  },
  {
    path: '/ucenter_questions',
    name: '常见问题',
    component: () => import('@/pages/ucenter/ucenter_questions')
  },
  {
    path: '/ucenter_about',
    name: '关于滇医通',
    component: () => import('@/pages/ucenter/ucenter_about')
  },
  {
    path: '/payCallback',
    name: '缴费成功',
    component: () => import('@/pages/ucenter/payCallback')
  },
  {
    path: '/TijianpayCallback',
    name: '缴费成功',
    component: () => import('@/pages/ucenter/TijianpayCallback')
  },
  {
    path: '/ucenter_paydetail',
    name: '费用详情',
    component: () => import('@/pages/ucenter/ucenter_paydetail')
  },
  {
    path: '/ucenter_pay_detail',
    name: '缴费详情',
    component: () => import('@/pages/ucenter/ucenter_pay_detail')
  },
  {
    path: '/pay_detail',
    name: '缴费详情',
    component: () => import('@/pages/ucenter/pay_detail')
  },
  {
    path: '/ucenter_question_detail',
    name: '常见问题详情',
    component: () => import('@/pages/ucenter/ucenter_question_detail')
  },
  {
    path: '/ucenter_question_list',
    name: '常见问题列表',
    component: () => import('@/pages/ucenter/ucenter_question_list')
  },
  {
    path: '/ucenter_address_add',
    name: '添加收货人',
    component: () => import('@/pages/ucenter/ucenter_address_add')
  },
  {
    path: '/ucenter_address_list',
    name: '收货人列表',
    component: () => import('@/pages/ucenter/ucenter_address_list')
  },
  {
    path: '/ucenterPlatIndex',
    name: '个人中心',
    component: () => import('@/pages/ucenter/ucenterPlatIndex')
  },
  {
    path: '/ucenter_medical_kit',
    name: '小药箱',
    component: () => import('@/pages/ucenter/ucenter_medical_kit')
  },
  {
    path: '/ucenter_add_card',
    name: '新建电子健康卡',
    component: () => import('@/pages/ucenter/ucenter_add_card')
  },
  {
    path: '/ucenter_add_card_new',
    name: '新建电子健康卡',
    component: () => import('@/pages/ucenter/ucenter_add_card_new')
  },
  {
    path: '/ucenter_card_info',
    name: '电子健康卡详情',
    component: () => import('@/pages/ucenter/ucenter_card_info')
  },
  {
    path: '/ucenter_card_info_new',
    name: '电子健康卡详情',
    component: () => import('@/pages/ucenter/ucenter_card_info_new')
  },
  {
    path: '/ucenter_order_evaluate',
    name: '挂号评价',
    // component: () => import('@/pages/ucenter/ucenter_order_evaluate')
    component: () => import('@/pages/ucenter/ucenter_order_evaluate')
  },
  {
    path: '/ucenter_order_evaluate_new',
    name: '挂号评价',
    // component: () => import('@/pages/ucenter/ucenter_order_evaluate')
    component: () => import('@/pages/ucenter/ucenter_order_evaluate_new')
  },
  {
    path: '/ucenter_update_patient',
    name: '编辑就诊人',
    component: () => import('@/pages/ucenter/ucenter_update_patient')
  },
  {
    path: '/ucenter_update_patient_new',
    name: '编辑就诊人',
    component: () => import('@/pages/ucenter/ucenter_update_patient_new')
  },
  {
    path: '/text111',
    name: 'text',
    component: () => import('@/pages/ucenter/text')
  },
  {
    path: '/ucenter_health_card',
    name: '电子健康卡',
    component: () => import('@/pages/ucenter/ucenter_health_card')
  },
  {
    path: '/ucenter_health_card_new',
    name: '电子健康卡',
    component: () => import('@/pages/ucenter/ucenter_health_card_new')
  },
  {
    path: '/ucenter_overclinic_records',
    name: '加班门诊',
    component: () => import('@/pages/ucenter/ucenter_overclinic_records')
  },
  {
    path: '/ucenter_appoint_wxpay',
    name: '挂号缴费',
    component: () => import('@/pages/ucenter/ucenter_appoint_wxpay')
  },
  {
    path: '/ucenter_unbundle',
    name: '解绑申请',
    component: () => import('@/pages/ucenter/ucenter_unbundle')
  },
  {
    path: '/ucenter_unbundle_blacklist',
    name: '黑名单解绑申请',
    component: () => import('@/pages/ucenter/ucenter_unbundle_blacklist')
  },
  {
    path: '/ucenter_patient_manage',
    name: '就诊人管理',
    component: () => import('@/pages/ucenter/ucenter_patient_manage')
  },
  {
    path: '/ucenter_menzhen_pay',
    name: '门诊缴费',
    component: () => import('@/pages/ucenter/ucenter_menzhen_pay')
  },
  {
    path: '/ucenter_menzhen_detail',
    name: '缴费详情',
    component: () => import('@/pages/ucenter/ucenter_menzhen_detail')
  },
  {
    path: '/ucenter_menzhen_detail_v3',
    name: '缴费详情',
    component: () => import('@/pages/ucenter/ucenter_menzhen_detail_v3')
  },
  {
    path: '/ucenter_clear_storage',
    name: '账号信息',
    component: () => import('@/pages/ucenter/ucenter_clear_storage')
  },
  {
    path: '/ucenter_protocol',
    name: '滇医通用户协议',
    meta: { privacyPolicyDetail: true, privacyPolicyDocType: 'user_agreement' },
    component: () => import('@/pages/ucenter/ucenter_protocol')
  },
  {
    path: '/ucenter_feedback_type',
    name: '选择类型',
    component: () => import('@/pages/ucenter/ucenter_feedback_type')
  },
  {
    path: '/ucenter_feedback_success',
    name: '意见反馈',
    component: () => import('@/pages/ucenter/ucenter_feedback_success')
  },
  {
    path: '/ucenter_appointment_order_details',
    name: '订单详情',
    component: () => import('@/pages/ucenter/ucenter_appointment_order_details')
  },
  {
    path: '/contact',
    name: '订单详情',
    component: () => import('@/pages/ucenter/contact')
  },
  { path: '/ucenter_face', name: '人脸识别', component: () => import('@/pages/ucenter/ucenter_face') },
  {
    path: '/healthy_card_new',
    name: '电子健康卡',
    component: () => import('@/pages/ucenter/healthy_card_new')
  }
]

export default ucenter
